import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'

function fetchAdvertisers () {
  const database = firebase.firestore()
  return database.collection('advertisers').get()
    .then(res => {
      const advertisers = []
      res.forEach(client => {
        advertisers.push({
          id: client.id,
          data: client.data()
        })
      })
      return advertisers
    })
    .catch(err => console.log(err))
}
function createAdvertiser (advertiser) {
  const database = firebase.firestore()
  return new Promise(resolve => {
    resolve(database.collection('advertisers').add(advertiser))
  })
    .then(res => {
      return res
    })
    .catch(err => console.log(err))
}
function updateAdvertiser (advertiser) {
  const database = firebase.firestore()
  return new Promise(resolve => {
    resolve(database.collection('advertisers').doc(advertiser.id).update(advertiser.data))
  })
    .then(res => {
      return true
    })
    .catch(err => console.log(err))
}
function getAdvertiserById (id) {
  const database = firebase.firestore()
  return new Promise(resolve => {
    resolve(database.collection("advertisers").doc(id).get())
  })
    .then(res => {
      return res.data()
    })
}

export default {
  fetchAdvertisers,
  createAdvertiser,
  updateAdvertiser,
  getAdvertiserById
}
